
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app-privacy-policy",
      function () {
        return require("private-next-pages/app-privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app-privacy-policy"])
      });
    }
  